import { FigureTwicpics } from '@studiometa/ui';

/**
 *
 */
export default class Figure extends FigureTwicpics {
  static config = {
    ...FigureTwicpics.config,
    name: 'Figure',
  };

  /**
   * @returns {string} domain
   */
  get domain() {
    if (
      window.location.hostname === 'unistra.studiometa.dev' ||
      window.location.hostname === 'www.unistra.fr' ||
      window.location.hostname === 'prod-unistra.studiometa.dev' ||
      window.location.hostname === 'prod-unistra.unistra.fr'
    ) {
      return 'cdn.studiometa.fr';
    }

    return '';
  }

  /**
   * @returns {string} path
   */
  get path() {
    if (window.location.hostname === 'unistra.studiometa.dev') {
      return 'https://unistra.studiometa.dev';
    }

    if (
      window.location.hostname === 'www.unistra.fr' ||
      window.location.hostname === 'prod-unistra.studiometa.dev' ||
      window.location.hostname === 'prod-unistra.unistra.fr'
    ) {
      return 'https://www.unistra.fr';
    }

    return '';
  }

  /**
   * formatSrc
   * @param {Stirng} src
   * @returns {string}
   * only use Twicpics formating for the given urls
   */
  formatSrc(src) {
    if (
      window.location.hostname === 'unistra.studiometa.dev' ||
      window.location.hostname === 'www.unistra.fr' ||
      window.location.hostname === 'prod-unistra.studiometa.dev' ||
      window.location.hostname === 'prod-unistra.unistra.fr'
    ) {
      return super.formatSrc(src);
    }

    return src;
  }
}
